import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS_INFO, SMS_LINK } from "@/data/businessInfo";
const HomeFinalCTA = () => (
  <section className="bg-secondary text-secondary-foreground" data-no-reveal>
    <div className="max-w-[1400px] mx-auto px-6 py-16 md:py-20">
      <h2 className="font-heading text-3xl md:text-4xl max-w-2xl">Let’s Find the Right Finish for Your Space</h2>
      <p className="mt-6 text-secondary-foreground/85 max-w-xl leading-relaxed">Send photos of your space, your inspiration and your town. We’ll help you explore the next step for your project.</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-4"><Button asChild size="lg"><a href={SMS_LINK}><MessageSquare className="h-4 w-4" />Text Project Photos</a></Button><Button asChild variant="outline" size="lg" className="bg-transparent text-secondary-foreground border-secondary-foreground/50 hover:bg-secondary-foreground/10 hover:text-secondary-foreground"><Link to="/contact/">Request a Free Estimate</Link></Button></div>
      <a href={BUSINESS_INFO.phoneLink} className="mt-6 inline-block py-2 text-sm underline underline-offset-4">Call {BUSINESS_INFO.phone}</a>
    </div>
  </section>
);
export default HomeFinalCTA;
